// only enable old jquery vrsion + no conflict mode if we are on online catalog pages 
if(document.querySelector('.catalog') || document.querySelector('.eifu') || document.querySelector('.ks-legacy')) {
  // jQuery.noConflict();
  // var $ = jQuery.noConflict();
  // $.noConflict();

  if (!String.prototype.includes) {
      String.prototype.includes = function(search, start) {
        if (typeof start !== 'number') {
          start = 0;
        }

        if (start + search.length > this.length) {
          return false;
        } else {
          return this.indexOf(search, start) !== -1;
        }
      };
    }
}

